
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import { cloneDeep, isEqual } from "lodash-es";

import LIST_DIRECTORY from "@/apollo/directory/ListDirectorySimple.gql";

import DirectoryMixins from "@/mixins/directory/DirectoryMixins";
import Breadcrumbs from "@/components/breadcrumbs/BreadcrumbsNew.vue";
import ContractorCollectionFilters from "@/components/companyContractors/ContractorCollectionFiltersNew2.vue";
import DefaultContentLayout from "@/components/scaffold/DefaultContentLayoutNew.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import InvitationSideBar from "@/components/companyContractors/invitationsidebarNew.vue";

import ActionPanel from "@/components/common/ActionsPanel.vue";

import {
  getFiltersDataFromQuery,
  joinQueryValues,
} from "@/helpers/router/prepareFiltersQuery";
import {
  getPaginationDataFromQuery,
  getPaginationQuery,
} from "@/helpers/router/preparePaginationQuery";
import NavGrayArrow from "@/components/icons//NavGrayArrow.vue";
import paginationConfig from "@/data/paginationConfig";
import contractorsCollectionFiltersTemplate from "@/data/filtersTemplates/contractorsCollectionFiltersTemplateV2";

import UiButton from "@/components/button/ui-button.vue";
import PlusIcon from "@/components/icons/PlusIconNew.vue";
import {
  Company,
  Contractor,
  User,
  Contractor_Bool_Exp,
  User_Profile_Bool_Exp,
} from "@/generated/graphql";
import RouteNames from "@/entities/RouteNames";
import Roles from "@/entities/Roles";
import PaginationConfig from "@/entities/PaginationConfig";
import ContractorsCollectionFiltersQuery from "@/entities/filters/ContractorsCollectionFiltersQueryV2";
import { getEmptyFiltersResultMessage } from "@/helpers/lists/emptyListMessagesNew";
import CompanyContractorsCollectionCard from "@/components/companyContractors/CompanyContractorsCollectionCard.vue";
import ElementsSizeProvider from "@/components/uiSize/ElementsSizeProvider.vue";
import CardsContainer from "@/components/card/CardsContainer.vue";
import LIST_MANAGERS from "@/apollo/managers/ListSingleManagers.gql";
import EmptyListImageContractors from "@/components/icons/emptyListImages/EmptyListImageContractors.vue";
import getStateQueryConditions from "@/helpers/locations/stateQueryConditions";

@Component({
  components: {
    EmptyListImageContractors,
    NavGrayArrow,
    CardsContainer,
    ElementsSizeProvider,
    CompanyContractorsCollectionCard,
    ContractorCollectionFilters,
    DefaultContentLayout,
    CardPagination,
    EmptyListPlaceholder,
    LoadingOverlay,
    Breadcrumbs,
    PlusIcon,
    UiButton,
    InvitationSideBar,
    ActionPanel,
  },
  apollo: {
    contractors: {
      query: LIST_DIRECTORY,
      variables() {
        return this.directoryFilter;
      },
      skip() {
        return this.skipQuery;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.contractor.length;
        this.$emit("contractorsTotalChanged", this.paginationConfig.total);
        const sortContarctor = data.contractor.sort((a, b) => {
          const dateA = new Date(a.user.created_at);
          const dateB = new Date(b.user.created_at);
          return dateB.getTime() - dateA.getTime();
        });
        return sortContarctor;
      },
    },
    managers: {
      query: LIST_MANAGERS,
      variables() {
        return this.managerArgs;
      },
      update(data) {
        this.hasAllResourceAccess = data.manager[0].resources_access_allowed;
        return data.manager.resources_access_allowed;
      },
    },
  },
})
export default class CompanyContractorsDBNew extends mixins(DirectoryMixins) {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false })
  readonly favoriteContractors!: boolean;
  @Prop({ type: Boolean, default: false }) readonly canAddProject!: boolean;
  @Prop({ type: Boolean, default: false }) readonly managerDatabase!: boolean;

  contractors: Contractor[] | undefined = undefined;

  paginationConfig: PaginationConfig = { ...paginationConfig };
  hasAllResourceAccess: boolean = false;

  directoryFilters: ContractorsCollectionFiltersQuery = cloneDeep(
    contractorsCollectionFiltersTemplate
  );

  containerClasses: string = "h-full";

  get isManagerDatabase(): boolean {
    return this.$route.name === RouteNames.MANAGER_CONTRACTOR_DATABASE;
  }

  get managerHasAccess(): boolean {
    return this.isManagerDatabase || this.favoriteContractors;
  }

  // handleSelection(selectedItem: any) {
  //     const { page, limit } = this.paginationConfig;
  //      const nextOffset = page * limit - limit;
  //      const userIds = selectedItem.userId;
  //      const filterConditions: Contractor_Bool_Exp[] = [
  //       {
  //         approved: { _eq: true },
  //         deleted: { _eq: false },
  //         user: {
  //           id: {
  //             _in: userIds
  //           }
  //         },
  //         _or: [
  //           {
  //             user: {
  //               archived: {
  //                 _is_null: true,
  //               },
  //             },
  //           },
  //           {
  //             user: {
  //               archived: {
  //                 _eq: false,
  //               },
  //             },
  //           },
  //         ],
  //       },
  //     ];
  //     if(userIds.length !== 0){
  //     this.$apollo.queries.contractors.refetch({
  //       offset: nextOffset,
  //       limit: limit ? limit : 50,
  //       where: {
  //         _and: filterConditions,
  //       },
  //       id: this.currentUser.id,
  //     });
  //     }
  //     else{
  //     this.handleClear();
  //     }
  //   }

  get empty(): boolean {
    if (!this.contractors) {
      return false;
    }
    return this.contractors.length === 0;
  }

  get hasData(): boolean {
    return Boolean(this.contractors);
  }

  // handleClear(): void{
  //    const { page, limit } = this.paginationConfig;
  //    const nextOffset = page * limit - limit;
  //      const filterCondit: Contractor_Bool_Exp[] = [
  //       {
  //         approved: { _eq: true },
  //         deleted: { _eq: false },
  //         _or: [
  //           {
  //             user: {
  //               archived: {
  //                 _is_null: true,
  //               },
  //             },
  //           },
  //           {
  //             user: {
  //               archived: {
  //                 _eq: false,
  //               },
  //             },
  //           },
  //         ],
  //       },
  //     ];

  //  this.$apollo.queries.contractors.refetch({
  //       offset: nextOffset,
  //       limit: limit ? limit : 50,
  //       where: {
  //         _and: filterCondit,
  //       },
  //       id: this.currentUser.id,
  //     });
  // }

  get managerArgs() {
    const filterConditions = [
      {
        user: {
          id: { _eq: this.currentUser.id },
        },
      },
    ];
    return {
      where: {
        _and: filterConditions,
      },
    };
  }
  get invitationButtonShown(): boolean {
    return !this.favoriteContractors && this.filtersEmpty;
  }

  get filtersEmpty(): boolean {
    return isEqual(this.directoryFilters, contractorsCollectionFiltersTemplate);
  }

  get emptyListPlaceholder(): string {
    if (this.favoriteContractors) {
      if (this.filtersEmpty) {
        return "You have no favorite resources at the moment, but you might like someone in the Talent Directory";
      }

      return getEmptyFiltersResultMessage("favorite resources");
    }

    if (this.filtersEmpty) {
      if(!this.isManager){
      return "Start adding resources to your Talent Directory";
      }
      else{
        return 'Your Admin has not yet added Resources to your database';
      }
    }

    return getEmptyFiltersResultMessage("resources");
  }

  get loading(): boolean {
    return (
      this.$apollo.queries.contractors.loading ||
      this.$apollo.queries.managers.loading
    );
  }

  get isManager(): boolean {
    return this.currentUser.role === Roles.MANAGER;
  }

  get currentUserManagerId(): string | undefined {
    return this.currentUser?.role === Roles.MANAGER
      ? this.currentUser.manager?.id
      : undefined;
  }

  get isResourcesPage(): boolean {
    return this.$route.path.includes("/company_database");
  }

  get directoryFilter(): any {
    const { page, limit } = this.paginationConfig;

    const {
      countries,
      states,
      cities,
      titles,
      skills,
      managers,
      projects,
      name,
      available,
      minRate,
      maxRate,
    } = this.directoryFilters;

    const nextOffset = page * limit - limit;
    const filterConditions: any[] = [
      {
        approved: { _eq: true },
        deleted: { _eq: false },
        _or: [
          {
            user: {
              archived: {
                _is_null: true,
              },
            },
          },
          {
            user: {
              archived: {
                _eq: false,
              },
            },
          },
        ],
      },
    ];

    if (this.favoriteContractors) {
      const managerConditions = !this.currentUserManagerId
        ? {}
        : {
            managers: {
              _and: [
                {
                  manager: {
                    id: {
                      _eq: this.currentUserManagerId,
                    },
                  },
                },
                {
                  approved: {
                    _eq: true,
                  },
                },
              ],
            },
          };

      filterConditions.push({
        _and: [
          {
            user: {
              favorited_by_users: {
                favorited_by_id: {
                  _eq: this.currentUser.id,
                },
              },
            },
          },
          managerConditions,
        ],
      });
    }

    if (this.isManager && this.isManagerDatabase) {
      const managerId = this.currentUser.manager!.id;

      filterConditions.push({
        managers: {
          _and: [
            { manager_id: { _eq: managerId } },
            { approved: { _eq: true } },
          ],
        },
      });
    }

    if (name && name.userId?.length && !(states && states.userId?.length)) {
      filterConditions.push({
        user: {
          id: {
            _in: name.userId,
          },
        },
      });
    } else if (
      !(name && name.userId?.length) &&
      states &&
      states.userId?.length
    ) {
      filterConditions.push({
        user: {
          id: {
            _in: states.userId,
          },
        },
      });
    }

    if (name && name?.userId?.length && states && states?.userId?.length) {
      const matchedNameUserIds = name.userId;
      const macthedRegionValue = states.matchValue;

      const nameConditions: any[] = [
        { profile: { job_title: { _ilike: `%${macthedRegionValue}%` } } },
        {
          user_profile_by_managements: {
            job_title: { _ilike: `%${macthedRegionValue}%` },
          },
        },

        {
          user_profile_by_managements: {
            state: { _ilike: `%${macthedRegionValue}%` },
          },
        },
        { given_name: { _ilike: `%${macthedRegionValue}%` } },
        { family_name: { _ilike: `%${macthedRegionValue}%` } },
        { experiences: { job_title: { _ilike: `%${macthedRegionValue}%` } } },
        { profile: { country: { _ilike: `%${macthedRegionValue}%` } } },
        { profile: { state: { _ilike: `%${macthedRegionValue}%` } } },
        { profile: { city: { _ilike: `%${macthedRegionValue}%` } } },
        {
          user_profile_by_managements: {
            country: { _ilike: `%${macthedRegionValue}%` },
          },
        },
        {
          profile: {
            skills: { skill: { name: { _ilike: `%${macthedRegionValue}%` } } },
          },
        },
        {
          user_profile_by_managements: {
            city: { _ilike: `%${macthedRegionValue}%` },
          },
        },
        {
          user_profile_by_managements: {
            country: { _ilike: `%${macthedRegionValue}%` },
          },
        },
        {
          experiences: { company_name: { _ilike: `%${macthedRegionValue}%` } },
        },
        { certifications: { title: { _ilike: `%${macthedRegionValue}%` } } },
        {
          certifications: {
            institution: { _ilike: `%${macthedRegionValue}%` },
          },
        },
        { educations: { institution: { _ilike: `%${macthedRegionValue}%` } } },
        { educations: { title: { _ilike: `%${macthedRegionValue}%` } } },
        {
          profile: {
            languages: {
              language: { name: { _ilike: `%${macthedRegionValue}%` } },
            },
          },
        },
        {
          profile: {
            industries: {
              industry: { name: { _ilike: `%${macthedRegionValue}%` } },
            },
          },
        },
      ];
      filterConditions.push({
        user: {
          id: {
            _in: matchedNameUserIds,
          },
          _or: nameConditions,
        },
      });

      const numericRegex = /^-?\d+(\.\d*)?$/;
      if (numericRegex.test(macthedRegionValue)) {
        const numericName = macthedRegionValue;
        nameConditions.push(
          { profile: { min_rate: { _eq: numericName } } },
          { profile: { max_rate: { _eq: numericName } } },
          { user_profile_by_managements: { min_rate: { _eq: numericName } } },
          { user_profile_by_managements: { max_rate: { _eq: numericName } } }
        );
      }
    }
    if (countries.length) {
      filterConditions.push({
        user: {
          _or: [
            { profile: { country: { _in: countries } } },

            { user_profile_by_managements: { country: { _in: countries } } },
          ],
        },
      });
    }

    if (cities.length) {
      filterConditions.push({
        user: {
          _or: [
            {
              profile: {
                city: { _in: cities },
              },
            },
            { user_profile_by_managements: { city: { _in: cities } } },
          ],
        },
      });
    }

    if (available !== "all") {
      filterConditions.push({
        user: {
          available: { _eq: available === "yes" },
        },
      });
    }

    if (titles.length) {
      filterConditions.push({
        user: {
          _or: [
            {
              profile: {
                job_title: { _in: titles },
              },
            },
            {
              user_profile_by_managements: {
                job_title: { _in: titles },
              },
            },
            {
              experiences: {
                job_title: { _in: titles },
              },
            },
          ],
        },
      });
    }

    if (skills.length) {
      filterConditions.push({
        user: {
          profile: {
            skills: {
              skill_id: { _in: skills },
            },
          },
        },
      });
    }

    if (managers.length) {
      filterConditions.push({
        managers: {
          _and: [
            { manager_id: { _in: managers } },
            { approved: { _eq: true } },
          ],
        },
      });
    }

    if (projects.length) {
      filterConditions.push({
        project_activities: {
          project: {
            id: { _in: projects },
          },
        },
      });
    }

    if (minRate || maxRate) {
      const minConditions: User_Profile_Bool_Exp[] = [];
      const maxConditions: User_Profile_Bool_Exp[] = [];

      if (minRate) {
        minConditions.push({ min_rate: { _gte: minRate } });
        maxConditions.push({ max_rate: { _gte: minRate } });
      }
      if (maxRate) {
        minConditions.push({ min_rate: { _lte: maxRate } });
        maxConditions.push({ max_rate: { _lte: maxRate } });
      }

      if (minConditions.length && maxConditions.length) {
        filterConditions.push({
          user: {
            _and: [{}],
            _or: [
              {
                profile: {
                  _or: [{ _and: minConditions }, { _and: maxConditions }],
                },
              },
              {
                user_profile_by_managements: {
                  _or: [{ _and: minConditions }, { _and: maxConditions }],
                },
              },
            ],
          },
        });
      }
    }

    return {
      offset: nextOffset,
      limit: limit ? limit : 50,
      where: {
        _and: filterConditions,
      },
      id: this.currentUser.id,
    };
  }

  get queryPropsToWatch(): string {
    return JSON.stringify([this.directoryFilters, this.paginationConfig]);
  }

  get queryParams(): {
    filters: ContractorsCollectionFiltersQuery;
    pagination: PaginationConfig;
  } {
    const query = this.$route.query;
    const { min_rate: minRate, max_rate: maxRate, ...queryParams } = query;

    const queryData = {
      minRate,
      maxRate,
      ...queryParams,
    };

    return {
      filters: getFiltersDataFromQuery<ContractorsCollectionFiltersQuery>(
        contractorsCollectionFiltersTemplate,
        queryData
      ),
      pagination: {
        ...this.paginationConfig,
        ...getPaginationDataFromQuery(query),
      },
    };
  }

  get isChosenPageEmpty(): boolean {
    const collectionEmpty = this.contractors?.length === 0;
    const notFirstPage = this.paginationConfig.page !== 1;

    return !this.loading && collectionEmpty && notFirstPage;
  }

  @Watch("queryPropsToWatch")
  updateQuery(): void {
    if (this.isChosenPageEmpty) {
      return this.showFirstPage();
    }

    const paginationQuery = getPaginationQuery(this.paginationConfig);

    const { minRate, maxRate, ...filtersData } = this.directoryFilters;

    const query = joinQueryValues({
      ...paginationQuery,
      ...filtersData,
      min_rate: minRate,
      max_rate: maxRate,
    });

    if (isEqual(query, this.$route.query)) {
      return;
    }

    this.$router.push({ query }).catch(() => {});
  }

  @Watch("$route.query", { immediate: true })
  onQueryChange(): void {
    const { filters, pagination } = this.queryParams;

    this.directoryFilters = filters;
    this.paginationConfig = pagination;
  }

  mounted(): void {
    if (!!this.company) {
      this.$apollo.queries.contractors.skip = false;
    }
  }

  showFirstPage(): void {
    this.paginationConfig = {
      ...this.paginationConfig,
      page: paginationConfig.page,
    };
  }

  managerAccessApproved(contractor: Contractor): boolean {
    return Boolean(contractor?.user.contracts[0]?.managers[0]?.approved);
  }

  updateFilters(updatedFilters: ContractorsCollectionFiltersQuery): void {
    const dataEqual = isEqual(this.directoryFilters, updatedFilters);

    if (dataEqual) {
      return;
    }

    const { minRate, maxRate, ...filtersData } = updatedFilters;

    const query = joinQueryValues({
      ...filtersData,
      min_rate: minRate,
      max_rate: maxRate,
    });

    this.$router.push({ query }).catch(() => {});
  }

  resetFilters(): void {
    if (isEqual(this.directoryFilters, contractorsCollectionFiltersTemplate)) {
      return;
    }

    this.directoryFilters = cloneDeep(contractorsCollectionFiltersTemplate);
    this.paginationConfig = { ...paginationConfig };
  }

  message(userId: string): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: userId,
      },
    });
  }

  handleRefetch(): void {
    this.$apollo.queries.contractors.refetch();
    this.$emit("refetchRequests");
    this.$emit("refetchRequestsContractorsNumber");
  }

  prepareFilters(filterValues: Record<string, any>): void {
    this.directoryFilters = {
      ...this.directoryFilters,
      ...filterValues,
    };
  }
}
